// extracted by mini-css-extract-plugin
module.exports = {"details":"LocationDetails_details__aIvJH","text_input":"LocationDetails_text_input__2hPXI","submit_button":"LocationDetails_submit_button__9Qx6W"};